export const APPLICATION_VERSION = '2.2.3'; export const APPLICATION_ENV = 'pre-production';
